import { html, render } from "lit-html";
import Input from "../engine/input";
import { Commands } from "../engine/commands";

class CreditsDialog {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".log");
  }

  activate(context) {
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
    render(this.getControlsTemplate(), this.dialog);
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");
  }

  handleClick(ev) {
    if (!this.dialog.contains(ev.target) || ev.target.matches(".button-ok")) {
      return Commands.HideDialog;
    }
  }

  handleInput(input) {
    if (input == Input.Cancel) {
      return Commands.HideDialog;
    }

    return false;
  }

  handleRightClick(ev, stage) {
  }

  rescale() {
    return;
  }

  render(stage) {
    // none
  }

  getControlsTemplate() {
    return html`
      <div class="credits">
        <h2>Caldera</h2>
        <p>&copy; 2022–2023 School of Product Design, University of Canterbury</p>

        <h3>Original Story</h3>
        <p>Class of PROD226, 2022</p>

        <h3>Narrative Design, Writing &amp; 2D Art</h3>
        <p>Adriaan Bakker<br>
        Oliver Coates<br>
        Lucas Davey<br>
        Aaron Lin<br>
        Alexander Metzler<br>
        Cameron Rooney<br>
        Kris Sian</p>

        <h3>Course Coordinator, Producer, Engine Programming, UI</h3>
        <p>Mark Rickerby</p>
      </div>
      <footer class="dialog-footer">
        <button class="button-ok">Ok</button>
      </footer>
    `;
  }
}

export default CreditsDialog;